import React from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationKey } from '../../i18n/translationKeys';
import { Tag } from '../../ui/Tag/Tag';
import { Tooltip } from '../../ui/Tooltip/Tooltip';

interface RelanceExpectedTagProps {
    testId?: string;
}

// The row it sits in takes no focus, so the hint is also spelled out for screen readers.
export const RelanceExpectedTag: React.FC<RelanceExpectedTagProps> = ({ testId }) => {
    const { t } = useTranslation();
    const hint = t(TranslationKey.Home.Agenda.ExpectedHint);

    return (
        <Tooltip content={hint}>
            {describedById => (
                <Tag tone="neutral" testId={testId} aria-describedby={describedById}>
                    {t(TranslationKey.Home.Agenda.Expected)}
                    <span className="sr-only">{hint}</span>
                </Tag>
            )}
        </Tooltip>
    );
};
